import { ClientConfiguration } from "./client-configuration";
import { EWalletConfiguration } from "./ewallet-configuration";
import { NotificationsConfiguration } from "./notifications-configuration";
import {
  PaymentCenterConfiguration,
  QuickPayType,
} from "./payment-center-configuration";
import { ScheduledPaymentsConfiguration } from "./scheduledpayments-configuration";

export interface CombinedConfiguration {
  client: ClientConfiguration;
  paymentCenter: PaymentCenterConfiguration;
  notifications: NotificationsConfiguration;
  scheduledPayments: ScheduledPaymentsConfiguration;
  ewallet: EWalletConfiguration;
}

export interface Configuration extends CombinedConfiguration {
  fetchfail?: boolean;
  applicationName?: string | null;
}

export function createDefaultConfig(
  customerKey: string | null,
  idPId: string | null,
): Configuration {
  return {
    client: {
      clientId: null,
      customerKey,
      idPId,
      translationsProjectId: import.meta.env
        .REACT_APP_ROOT_TRANSLATIONS_PROJECT_ID!,
    },
    paymentCenter: {
      clientId: null,
      customerKey,
      idPId,
      statementsEnabled: false,
      accountTypes: {},
      defaultFees: {},
      quickPayments: {
        enabled: false,
        captchaEnabled: false,
        deepLinkingOnly: false,
        quickPayType: QuickPayType.Validated,
        customerDetails: {
          cellPhone: true,
          note: true,
          companyName: true,
        },
      },
      widgets: {
        editingEnabled: false,
      },
      quickPayTrackingProperties: [],
      registrationTrackingProperties: [],
      notifications: {
        sendNotifications: true,
        sendWelcomeEmail: true,
        sendEStatementEnrollment: true,
        sendPaymentReminder: true,
        sendRecurringPaymentReminder: true,
        sendPastDue: true,
        daysBeforeDueDateToSendPaymentDueReminder: 3,
        daysBeforeDueDateToSendPaymentScheduledReminder: 3,
        daysAfterDueDateToSendPastDue: 9,
      },
      applicationName: null,
      payByText: {
        enabled: false,
      },
    },
    notifications: {
      clientId: null,
      customerKey,
      idPId,
      enableSMS: false,
      enableEmail: false,
    },
    ewallet: {
      clientId: null,
      customerKey,
      idPId,
      paymentGateway: 0,
      debitCardOnly: false,
    },
    scheduledPayments: {
      clientId: null,
      customerKey,
      idPId,
      lockScheduledDueAmount: false,
    },
    applicationName: null,
  };
}
